// Result-code chip palette. Small, saturated hex values so white text stays
// legible on 9x9 trial cells. Kept in one place so the configuration picker
// and the data-collection chips agree on what's available.
//
// Colors are stored as plain strings on trial_result_codes.color; a practice
// may end up with an off-palette value from a past manual entry, so the
// picker surfaces any unknown current color as a "custom" swatch rather
// than dropping it on save.

export interface ResultCodeColor {
    value: string;
    name: string;
}

export const RESULT_CODE_COLORS: ResultCodeColor[] = [
    { value: '#3f8f68', name: 'Green'  },
    { value: '#4a6fa5', name: 'Blue'   },
    { value: '#7a5a9f', name: 'Purple' },
    { value: '#b46a55', name: 'Rust'   },
    { value: '#d9934a', name: 'Amber'  },
    { value: '#8c8f3e', name: 'Olive'  },
    { value: '#5a8c8c', name: 'Teal'   },
    { value: '#6b7280', name: 'Slate'  },
];

export const DEFAULT_RESULT_CODE_COLOR = RESULT_CODE_COLORS[0].value;
